import * as angular from 'angular';
import { DialogService } from './DialogService';

var dialogModule = angular.module('app.areas.common.dialog', []);

dialogModule
    .service(DialogService.$name, DialogService);

export default dialogModule.name;
